import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ChevronDown, ChevronUp } from 'react-feather';
import { Column } from 'components/shared/Layout';
import { legShape } from 'constants/propTypes';
import { DirectionContainer, StyledJourneySummaryHeader, Text } from 'components/shared/JourneyDigest/JourneyDigest.styles';

const ExchangeSummaryHeader = ({ onClick, open, outbound, inbound, isAllJourneysSelected }) => {
  const Chevron = open ? ChevronDown : ChevronUp;

  return (
    <StyledJourneySummaryHeader columns={4} onClick={onClick} data-cy="toggle-summary" isHighlighted={isAllJourneysSelected}>
      <Column span={1} alignItems="center">
        <Text underline>
          {open ? (
            <FormattedMessage id="exchangeSummary.hideSelectedTickets" />
          ) : (
            <FormattedMessage id="exchangeSummary.seeSelectedTickets" />
          )}
        </Text>
        <Chevron />
      </Column>

      <DirectionContainer span={1} justifyContent="flex-end" alignItems="center" show={true}>
        <FormattedMessage id="journeySummary.outbound" />
      </DirectionContainer>

      <DirectionContainer span={1} alignItems="center" show={true}>
        <FormattedMessage id="journeySummary.inbound" />
      </DirectionContainer>
    </StyledJourneySummaryHeader>
  );
};

ExchangeSummaryHeader.propTypes = {
  onClick: PropTypes.func,
  open: PropTypes.bool,
  outbound: PropTypes.arrayOf(legShape),
  inbound: PropTypes.arrayOf(legShape),
  isAllJourneysSelected: PropTypes.bool
};

export default ExchangeSummaryHeader;
